module.exports = "/images/milano-1.jpg";